exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textover3[data-v-003f53f2]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:10;overflow:hidden;line-height:1.5;white-space:pre-wrap}[data-v-003f53f2] .el-dropdown-menu__item{text-align:left}[data-v-003f53f2] .el-dropdown-menu__item i{color:#00c050}[data-v-003f53f2] .el-dropdown__caret-button{height:32px}\n", ""]);

// exports
